import { useState, useEffect } from "react";

import phone1 from "../assets/phone1.png";
import phone2 from "../assets/phone2.png";
import phone3 from "../assets/phone3.png";
import phone4 from "../assets/phone4.png";
import phone5 from "../assets/phone5.png";
import logo from "../assets/logo.png";

const images = [phone1, phone2, phone3, phone4, phone5];

const SLOTS = [
  { x: -148, y: "-50%", scale: 0.78, z: 2, opacity: 0.82 },
  { x: -82, y: "-50%", scale: 0.9, z: 3, opacity: 0.96 },
  { x: 0, y: "-50%", scale: 1, z: 4, opacity: 1 },
  { x: 82, y: "-50%", scale: 0.86, z: 1, opacity: 0.88 },
  { x: 138, y: "-50%", scale: 0.74, z: 0, opacity: 0.72 },
];

const SLOT_SCALE = {
  desktop: 1,
  tablet: 0.62,
  mobile: 0.54,
};

function getViewportMode() {
  if (typeof window === "undefined") return "desktop";
  if (window.innerWidth <= 500) return "mobile";
  if (window.innerWidth <= 900) return "tablet";
  return "desktop";
}

function AppShowcase() {
  const [offset, setOffset] = useState(0);
  const [mode, setMode] = useState(getViewportMode);

  useEffect(() => {
    const onResize = () => setMode(getViewportMode());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    let intervalId;

    const start = () => {
      intervalId = window.setInterval(() => {
        setOffset((current) => (current + 1) % images.length);
      }, 2400);
    };

    const stop = () => {
      if (intervalId) {
        window.clearInterval(intervalId);
        intervalId = undefined;
      }
    };

    start();

    const onVisibility = () => {
      if (document.hidden) {
        stop();
      } else {
        stop();
        start();
      }
    };

    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      stop();
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/tabkhatna-1.apk";
    link.download = "tabkhatna.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section
      id="download"
      className="
        box-border
        flex
        w-full
        justify-center
        bg-[#F8ECE5]
        px-5
        py-[60px]
        font-['Cairo']
        [direction:rtl]

        max-[500px]:px-4
        max-[500px]:py-10
      "
    >
      <div
        className="
          relative
          box-border
          flex
          min-h-[420px]
          w-full
          max-w-[1200px]
          items-center
          justify-between
          gap-10
          overflow-hidden
          rounded-[32px]
          bg-[#680B14]
          px-16
          py-16

          max-[900px]:flex-col-reverse
          max-[900px]:gap-[30px]
          max-[900px]:overflow-visible
          max-[900px]:px-6
          max-[900px]:py-10
          max-[900px]:text-center

          max-[500px]:rounded-[20px]
          max-[500px]:px-4
          max-[500px]:py-8
        "
      >
        <span
          className="
            absolute
            right-9
            top-7
            z-10
            flex
            h-10
            w-10
            items-center
            justify-center

            max-[900px]:right-5
            max-[900px]:top-4
          "
        >
          <img
            src={logo}
            alt="شعار طبختنا"
            className="block h-10 w-10 object-contain"
          />
        </span>

        <div
          className="
            z-[5]
            max-w-[520px]

            max-[900px]:max-w-full
          "
        >
          <h2
            className="
              m-[10px_0_14px]
              font-['Cairo']
              text-[34px]
              font-bold
              leading-[1.5]
              tracking-[0.3px]
              text-white

              max-[500px]:text-[22px]
            "
          >
            كل اللي بدك ياه ... بتطبيق واحد
          </h2>

          <p
            className="
              m-[0_0_30px]
              font-['Cairo']
              text-[15px]
              leading-[1.9]
              text-[#f3d6d6]

              max-[500px]:text-[13px]
            "
          >
            وجبة جاهزة، أطباق تحضير، أو مكونات طبخة كاملة — افتح طبختنا
            واطلب اللي عبالك.
          </p>

          <button
            type="button"
            onClick={handleDownload}
            className="
              cursor-pointer
              rounded-[30px]
              border-0
              bg-[#B20008]
              px-[34px]
              py-[14px]
              font-['Cairo']
              text-[15px]
              font-bold
              text-white
              transition-opacity
              duration-200
              ease-in-out
              hover:opacity-[0.85]
            "
          >
            حمّل التطبيق
          </button>
        </div>

        <div
          className="
            relative
            h-[380px]
            w-[420px]
            shrink-0
            overflow-hidden
            [perspective:900px]
            [transform:translateZ(0)]

            max-[900px]:h-[280px]
            max-[900px]:w-[300px]

            max-[500px]:h-[250px]
            max-[500px]:w-[260px]
          "
        >
          {images.map((src, index) => {
            const slot = SLOTS[(index - offset + images.length) % images.length];
            const x = Math.round(slot.x * SLOT_SCALE[mode]);

            return (
              <img
                key={src}
                src={src}
                alt={`شاشة تطبيق طبختنا ${index + 1}`}
                style={{
                  transform: `translate3d(calc(-50% + ${x}px), ${slot.y}, 0) scale(${slot.scale})`,
                  opacity: slot.opacity,
                  zIndex: slot.z,
                }}
                className="
                  absolute
                  left-1/2
                  top-1/2
                  w-[118px]
                  rounded-[20px]
                  pointer-events-none
                  shadow-[0_16px_36px_rgba(0,0,0,0.38)]
                  will-change-[transform,opacity]
                  [backface-visibility:hidden]
                  [transform-style:preserve-3d]
                  [transition:transform_0.62s_cubic-bezier(0.22,0.61,0.36,1),opacity_0.62s_ease]
                  [contain:layout_paint]

                  max-[900px]:w-[72px]
                  max-[900px]:rounded-[14px]

                  max-[500px]:w-[64px]
                  max-[500px]:rounded-[12px]
                "
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default AppShowcase;
